export const ALL_REQUESTS = 'ALL_REQUESTS'
export const REQUESTS = 'REQUESTS'
export const PROPOSALS = 'PROPOSALS'
export const CURRENCIES = 'CURRENCIES'
export const TIMEZONES = 'TIMEZONES'
export const INVOICES = 'INVOICES'
export const LIVE_CHATS = 'LIVE_CHATS'
export const MANAGERS = 'MANAGERS'
export const PLANS = 'PLANS'
export const BILLING = 'BILLING'
export const MINDBODY_CLASSES = 'MINDBODY_CLASSES'
export const STATS = 'STATS'
